module.exports = __webpack_public_path__ + "static/media/screen6.676c4284.png";